import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, Contrato } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PncpContratoService extends BaseResourceService<Contrato> {

  constructor(
    protected injector: Injector
  ) {
    super(`contratos`, injector);
  }

  public buscarPendenciasPncp(orgao, exercicio, tipo): Observable<any> {
    return this.http.get<any>(
      `${this.login.cidade.id}/${this.api}/pendencia-pncp/${orgao}/${exercicio}/${tipo}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public atualizarContratoPncp(id: number, cadastrado_pncp: boolean): Observable<any> {
    return this.http.post<any>(
      `${this.login.cidade.id}/${this.api}/atualizar-contrato-pncp`, { id, cadastrado_pncp },
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

}
